import { Box, Button, CssBaseline, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useRef, useState } from 'react'
import TwoHeadTable from '../../../../../../../components/TwoHeadTable'
// import EnergyReportingLogTable from '../../../../../../components/charts/energy_reporting/EnergyReportingLogTable'
import { InverterContext } from '../../../../../../../context/InverterContext'
import Pagination from '../../../../../../../components/general/Pagination'
import ExportContent from '../../../../../../../components/ExportContent'
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../../../utils'
import{WEB_KEY,PASS_KEY} from "../../../../../../../api/AxiosApi"
import generatePDF from 'react-to-pdf'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EnergyReportingLogTable from '../../../../../../../components/charts/energy_reporting/EnergyReportingLogTable'
let TableHeading

function DailyPlant1Log({SUB_PLANT}) {
    const { InverterChartData2, getInverterChartData2 } = useContext(InverterContext)

    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)
    const LOGIN_ID=sessionStorage.getItem('LoginID')
    const LCODE = sessionStorage.getItem('LCODE')
    const TYP="A"

    if (InverterChartData2?.length > 0) {
        const data = InverterChartData2[0]
        TableHeading = Object.keys(data)
    }
    useEffect(() => {
        getInverterChartData2(LOGIN_ID,LCODE,PASS_KEY,WEB_KEY,TYP,StartDate,EndDate,SUB_PLANT)
    }, [])


    function onRefreshData() {
        if (StartDate.length !== 0 && EndDate.length !== 0) {
            getInverterChartData2(LOGIN_ID,LCODE,PASS_KEY,WEB_KEY,TYP,StartDate,EndDate,SUB_PLANT)
        } else {
            alert('please provide any date')
        }

    }

    

    return (
        <EnergyReportingLogTable
            onRefreshData={onRefreshData}
            TableData={InverterChartData2}
            TableHead={TableHeading}
            ValueOf1={StartDate}
            ValueOf2={EndDate}
            onChangeValueOF1={(val) => setStartDate(val.target.value)}
            onChangeValueOF2={(val) => setEndDate(val.target.value)}
            radiationName={'Daily Energy Logs'}
        />

    )
}

export default DailyPlant1Log


